import { getAccountRef, getOrdersRef, getYieldETHRef, SERVER_TIMESTAMP } from '~/firebase'
import { fetchETHToFiat, fetchETHYield } from '~/utils/coinApi'
import { OrderObject, WalletAddress } from '~/types'


export function confirmOrder(orderObject: OrderObject) {
  return getOrdersRef().push(orderObject)
}

export function cancelOrder(key) {
  return getOrdersRef().child(key).remove()
}

export function orderPackageAgain(key) {
  console.warn('deprecated: orderPackageAgain')
  // return getProductsRef().child(id as string).once('value', snapshot => {
  //   const data: Product = snapshot.val()
  //   if (data && data.available) {
  //     getOrdersRef().push({
  //       computingPower: data.computingPower,
  //       description: data.description,
  //       duration: data.duration,
  //       name: data.name,
  //       price: data.price,
  //       productId: id,
  //     } as OrderedProduct)
  //   } else {
  //     alert('Sorry, product is no longer available.')
  //   }
  // })
}

export function payPackage(/* id: OrderedProduct['productId'] */) {
  console.warn('payPackage: Not yet implemented')
  // return getOrdersRef().child(id as string).once('value', snapshot => {
  //   const data: OrderedProduct = snapshot.val()
  //   const newData: PurchasedProduct = {
  //     computingPower: data.computingPower,
  //     description: data.description,
  //     duration: data.duration,
  //     name: data.name,
  //     price: data.price,
  //     productId: id,
  //     purchaseTimestamp: SERVER_TIMESTAMP,
  //   }

  //   getPurchasesRef().push({
  //     ...newData,
  //     computingPower: data.computingPower,
  //     description: data.description,
  //     duration: data.duration,
  //     name: data.name,
  //     price: data.price,
  //     productId: id,
  //     purchaseTimestamp: SERVER_TIMESTAMP, // set purchaseTimestamp once package is paid
  //   } as PurchasedProduct)
  // })
}

export function addWalletAddress(a: WalletAddress) {
  return getAccountRef().child('wallets').push({
    ...a,
    addedTimestamp: SERVER_TIMESTAMP,
  } as WalletAddress)
}

export function updateWalletsSelected(payload: {[key: string]: boolean}) {
  return getAccountRef().child('wallets').update(payload)
}

export function disableWallet(key: string) {
  return getAccountRef().child('wallets' + '/' + key).update(
    {disabled: true, disabledTimestamp: SERVER_TIMESTAMP} as Partial<WalletAddress>
  )
}

export function saveNote(note: string) {
  return getAccountRef().child('note').set(note)
}

export function fetchETHYieldData() {
  return Promise.all([
    fetchETHYield(),
    fetchETHToFiat(),
  ]).then(([yieldData, fiatValue]) => ({yieldData, fiatValue}))
}

export function fetchAndSaveETHYieldData() {
  return fetchETHYieldData().then(data => {
    const promise = getYieldETHRef().child(Date.now().toString()).set({...data.fiatValue, ...data.yieldData})
    return {...data, promise}
  })
}

// for (let i = 0; i < 100; i++) {
//   _firebase.database().ref(`graphs/yield/eth`).child(date.setDate(date.getDate() + 1)).set({...temp1.fiatValue, ...temp1.yieldData})
// }

//  _firebase.database().ref(`graphs/yield/eth`).child(+new Date()).set({...f.fiatValue, ...f.yieldData})



// WEBPACK FOOTER //
// ./src/firebase.actions.ts